/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import { Route } from "react-router-dom";
//import ReportMenu from "../menus/ReportMenu";
import Index from "./reports/index";
import CostChangesLogExcel from "./reports/CostChangesLogExcel";
import TableIDs from '../data/TableIDs';
import ExcelPosComparingActivity from "./ReportsCatering/ExcelPosComparingActivity";
import ReportMenuCatering from "../menus/ReportMenuCatering";
import ExcelComparingItemSales from "./ReportsCatering/ExcelComparingItemSales";
import ExcelCateringSalesHours from "./ReportsCatering/ExcelCateringSalesHours";
import TipsDisplay from "./DynamicDisplay/TipsDisplay";

type Props = {
    user: any,
    baseUrl: string,
    uiActions: any,
    ui: any,
    dataActions: any,
    data: Object
};

type State = {};

// SalesItemsReport // SalesReport
class ReportsItems extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        if (props.data[TableIDs.pseudoSelectorUIcomponentsModules] === undefined) {
            props.data[TableIDs.pseudoSelectorUIcomponentsModules] = { ...props.data.genericSelector };
        }
    }

    isActive = (key) => {
        return this.props.data[TableIDs.pseudoSelectorUIcomponentsModules].dataset
            .map(obj => obj.code).includes(key);
    };

    render() {
        const { baseUrl, user, ui, uiActions, dataActions, data, ActionQueue } = this.props;
        let routeProps = { baseUrl, user, ui, uiActions, dataActions, data, ActionQueue }

        const routes = [
            (<Route key={301} path={this.props.baseUrl + "/reports_catering/excel-pos-comparing-activity"} exact render={() => <ExcelPosComparingActivity {...routeProps} />} />),
            (<Route key={302} path={this.props.baseUrl + "/reports_catering/excel-comparing-item-sales"} exact render={() => <ExcelComparingItemSales {...routeProps} />} />),
            (<Route key={303} path={this.props.baseUrl + "/reports_catering/excel-catering-sales-hours"} exact render={() => <ExcelCateringSalesHours {...routeProps} />} />),
            (<Route key={291} path={this.props.baseUrl + "/reports_catering/tips-display"} exact render={() => <TipsDisplay {...routeProps} />} />),
           
        ].filter((route, index) => this.isActive(route.key));

        const homeRoute = (routes.length > 0)
            ? (<Route key={routes[0].key} path={this.props.baseUrl + "/reports_catering"} exact render={routes[0].props.render} />)
            : <div />

        return (
            <div>
                {this.props.isFromUserFavorites ? '' : <ReportMenuCatering baseUrl={this.props.baseUrl} data={this.props.data} />}
                {homeRoute}
                {routes}
            </div>
        );
    }
}

export default ReportsItems;
